import React, { useEffect, useState } from 'react';
import '../assets/css/carrer.css';
import '../assets/css/custom.css';
import '../assets/js/apply.js';
import bgImage from '../assets/Images/homeBackgroundImg.png';

import API_BASE_URL from "../../helper";

function Carrer() {

     const [carrers, setCarres] = useState([]);
     const [selectedCarrer, setSelectedCarrer] = useState(null);
    
    // Fetch All Carrer
    const fetchAllCarrers = async () => {
        try {
        const response = await fetch(`${API_BASE_URL}/api/carrer/all`);
        const data = await response.json();
        setCarres(data);
        } catch (error) {
        console.error("Failed to load Carrer", error);
        }
    };
    useEffect(() => {
      fetchAllCarrers();
    }, []);

    const handleApply = (carrer) => {
        setSelectedCarrer(carrer);
    };

    const [openDescriptionId, setOpenDescriptionId] = useState(null);

    const toggleDescription = (id) => {
        setOpenDescriptionId(openDescriptionId === id ? null : id);
    };

  return (
  <div>
    <div id="carrer-hero-section" className="d-flex justify-content-center align-items-center flex-column"
      style={{background: `url(${bgImage}) center/cover no-repeat`}}>
        <h2 className="text-uppercase hero-title">Work With Us</h2>
        <p className='hero-subheading'>Join our growing team and shape the future of technology with us.</p>
    </div>

    <section id='services' className='my-5'>
        <div className='container'>
            <div className='row justify-content-center mb-4'>
                <div className='col-md-8'>
                <h2 className='text-center'>Opportunities With Us..</h2>
                <p className='text-center'>Ready to take the next step in your career? Join our team and become part of a dynamic and growing organization. We look forward to welcoming you to the EZIO INFOTECH family!</p>
                </div>
            </div>

            <div className='row'>

                    {carrers.length > 0 ? (
                        carrers.map((carrer) => (
                            <div class="col-md-6 mb-3" key={carrer.id}>
                                <div class="postDiv px-3 py-2">
                                    <div class="">
                                        <div class="row justify-content-between">
                                            <div class="col-sm-6">
                                                <h5 class="m-0 p-0">
                                                <a href="#" class="text-dark p-0 m-0" >
                                                    <b>{carrer.position}</b>
                                                </a>
                                                </h5>                                
                                                <p class="text-dark mt-2 mb-0">{carrer.postDate}</p>
                                            </div>
                                            <div class="col-sm-6 text-end">
                                                <a href="#" id='applyBtn' onClick={() => handleApply(carrer)} class="btn text-white" data-bs-toggle="modal" data-bs-target="#applyModal">
                                                Apply <i id='apply-arrow' class=" fa-solid fa-arrow-right"></i>
                                                </a>
                                            </div>
                                        </div>

                                        <p className='m-0'><i class="fa-solid fa-bookmark text-primary"></i> {carrer.course}</p>
                                        <div className='d-flex gap-3'>
                                            <p className=''><i class="fa-solid fa-bookmark text-primary "></i> {carrer.jobType}</p>
                                            <p><i class="fa-solid fa-bookmark text-primary"></i> {carrer.experience}</p>
                                        </div>

                                        <div>
                                            <p className='m-0'><b>Skills</b></p>
                                            <p className='m-0' id='skills'>{carrer.skills}</p>
                                        </div>
                                        <div class="d-flex justify-content-between mt-2">
                                            <p className="text-primary readMore m-0" style={{ cursor: "pointer" }}
                                                onClick={() => toggleDescription(carrer.id)} >
                                                {openDescriptionId === carrer.id ? "Read less..." : "Read more..."}
                                            </p>
                                        </div>
                                        {/* Smooth Animated Description */}
                                        <div className={ openDescriptionId === carrer.id ? "description-wrapper open" : "description-wrapper" }>
                                            <p className="mt-2">{carrer.description}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p>No Carrer Available</p>
                    )}
            </div>


            {/* Apply Model */}
            <div class="modal fade" id="applyModal" tabindex="-1" aria-labelledby="applyModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
                    <div class="modal-content">
                        
                        <div class="modal-header applyHeader text-white">
                            <h5 class="modal-title text-dark" id="applyModalLabel">Apply Now</h5>
                            <button type="button" class="btn-close applyClose border border-0 text-dark btn-close-dark" data-bs-dismiss="modal"></button>
                        </div>
                        <form id="applyForm" enctype="multipart/form-data" class="p-3">
                            <div class="modal-body">
                                <div class="row g-3">

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Full Name</b></label>
                                        <input type="text" name="userFullName" id="userFullName" class="form-control" required placeholder='enter name'/>
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Phone No.</b></label>
                                        <input type="number" name="userPhoneNo" id="userPhoneNo" class="form-control" required placeholder='enter phone no.'/>
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Email</b></label>
                                        <input type="email" name="userEmail" id="userEmail" class="form-control" required placeholder='enter email'/>
                                    </div>

                                    <div class="col-md-6 mb-3">
                                        <label class="form-label text-dark"><b>Position</b></label>
                                        <input 
                                            type="text" 
                                            name="applyPosition" 
                                            id="applyPosition" 
                                            readOnly 
                                            className="form-control"
                                            value={selectedCarrer ? selectedCarrer.position : ""}
                                        />
                                    </div>

                                    <div class="col-md-12 mb-3">
                                        <label class="form-label text-dark"><b>Upload Resume (PDF/DOC)</b></label>
                                        <input type="file" class="form-control" name="userResume" id='userResume' accept=".pdf,.doc,.docx" />
                                    </div>
                                </div>
                            </div>

                            <div class="modal-footer">
                                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" class="btn fw-semibold" id='applyFormBtn'>Apply</button>
                            </div>
                        </form>			
                    </div>
                </div>
            </div>

            {/* ✅ Universal Success Modal */}
            <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content border-0 shadow-lg">

                        <div class="modal-header bg-success text-white">
                        <h5 class="modal-title fw-bold" id="successModalLabel">
                            <i class="bi bi-check-circle-fill me-2"></i> Success
                        </h5>
                        <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
                        </div>

                        <div class="modal-body text-center py-4 d-flex justify-content-center align-items-center flex-column">
                        <svg xmlns="http://www.w3.org/2000/svg" class="text-success mb-3" width="60" height="60" fill="currentColor" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 11.001 8a8 8 0 0115.999 0zM6.97 11.03a.75.75 0 001.06 0l4.992-4.992a.75.75 0 10-1.06-1.06L7.5 9.939 4.53 6.97a.75.75 0 10-1.06 1.06l3.5 3.5z"/>
                        </svg>
                        <h5 id="successMessage" class="fw-semibold text-dark">Action completed successfully!</h5>
                        </div>

                        <div class="modal-footer border-0 justify-content-center">
                            <button type="button" class="btn btn-success px-4" data-bs-dismiss="modal">OK</button>
                        </div>

                    </div>
                </div>
            </div>

        </div>
    </section>

  </div>
  )
}

export default Carrer;